//states/login.js
import { make } from "vuex-pathify"

const state = {
  mqttAuthorized: false,
  mqttTableUpdated: '',
  mqttConnected: false,
  mqttClient: null,
  origMqttClient: null,
  notification: null,
};

const mutations = make.mutations(state);

export default {
  namespaced: true,
  state,
  mutations
}